module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/hooks-lore-hook-actions-blueprints-create.json
// module id = 2143
// module chunks = 22706643316925